import React, { useEffect, useState } from "react";
import CheckoutLogin from "../../Checkout/CheckoutLogin";
import CheckoutAddress from "../../Checkout/CheckoutAddress";
import CheckoutSummary from "../../Checkout/CheckoutSummary";
import { chooseToken } from "../../../utils";
import CheckoutLoginNew from "../../Checkout/CheckoutLogin/indexnew";
import CheckoutAddressNew from "../../Checkout/CheckoutAddress/indexnew";
import CheckoutSummaryNew from "../../Checkout/CheckoutSummary/indexnew";
import styled from "styled-components";

const BuyNowContainerNew = () => {
  const { isGuestUser = false } = chooseToken();
  const [currentStep, setCurrentStep] = useState({ step: 0 });

  const changeStep = (stepNumber) => {
    setCurrentStep({ step: Number(stepNumber) });
  };

  useEffect(() => {
    if (isGuestUser) {
      setCurrentStep({ step: 1 });
    } else {
      setCurrentStep({ step: 2 });
    }
  }, [isGuestUser]);

  const InnerContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    background-color: #f5f5f5;
    min-height: 100vh;
    max-width: 1300px;
    width: 75%;

  `;

  const InnerLeft = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  
    min-height: 100vh;
    max-width: 1300px;
  `;

  return (
    <React.Fragment>
    
      <InnerContainer>
         <CheckoutLoginNew currentStep={currentStep} stepAction={changeStep} />
      <CheckoutAddressNew currentStep={currentStep} stepAction={changeStep} />
      <CheckoutSummaryNew currentStep={currentStep} stepAction={changeStep} />
      </InnerContainer>
    </React.Fragment>
  );
};

export default BuyNowContainerNew;
